import { AfterViewInit, Directive, ElementRef, HostListener, OnChanges, SimpleChanges } from "@angular/core"

@Directive({
  selector: "textarea[autoGrow]",
  standalone: false,
})
export class AutoGrowTextareaDirective implements AfterViewInit, OnChanges {
  constructor(private el: ElementRef<HTMLTextAreaElement>) {}

  ngAfterViewInit(): void {
    setTimeout(() => this.resize(), 0)
  }

  ngOnChanges(_changes: SimpleChanges): void {
    setTimeout(() => this.resize(), 0)
  }

  @HostListener("input")
  onInput(): void {
    this.resize()
  }

  private resize(): void {
    const node = this.el.nativeElement
    if (!node) return
    node.style.height = "auto"
    node.style.height = node.scrollHeight + "px"
  }
}
